import axios from 'axios'
import config from '../../../config'

let BloodPressureApi = {

  getBloodPressureTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/blood-pressure/card/?requestFrom=web');
  },
  postBloodPressureTracking(model) {
    return axios.post(config.apiUrl + 'tracking/blood-pressure/', model);
  },
  putBloodPressureTracking(model) {
    return axios.put(config.apiUrl + 'tracking/blood-pressure/', model);
  },
  deleteBloodPressureTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/blood-pressure/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  getBloodPressureTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/blood-pressure/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  }

};

export default BloodPressureApi



// WEBPACK FOOTER //
// ./src/api/Tracking/BloodPressure/index.js